import posthog from 'posthog-js';

// WHEEL-393: the palette opens from a keypress (mod+k) that only flips React
// state, so autocapture never sees it - this is the code-based capture case
// from .claude/rules/test-ids.md. Both events carry $session_id, so the
// Replay list can be filtered by `command_palette_opened`.
export type PaletteOpenTrigger = 'shortcut' | 'header_button';

export type PaletteAction =
  | 'nav'
  | 'company'
  | 'threat_search'
  | 'takedown_search'
  | 'takedown_open'
  | 'domain_360'
  | 'domain_lookup'
  | 'fp_report'
  | 'create_threat'
  | 'url_copy'
  | 'shortcuts_help';

export const capturePaletteOpened = (
  trigger: PaletteOpenTrigger,
  pathname: string,
): void => {
  if (!posthog.__loaded) return;
  posthog.capture('command_palette_opened', { trigger, pathname });
};

export const capturePaletteAction = (
  action: PaletteAction,
  hasQuery: boolean,
  pathname: string,
): void => {
  if (!posthog.__loaded) return;
  posthog.capture('command_palette_action', {
    action,
    has_query: hasQuery,
    pathname,
  });
};
